var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 4H0V12H8V4Z",
    fill: "#CAD8EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0H4V3H9V8H12V0Z",
    fill: "#CAD8EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyBlue);
export default __webpack_public_path__ + "static/media/copy_blue.8674ffb13bd0b651e92cf1dfea9b5585.svg";
export { ForwardRef as ReactComponent };